import cn from 'classnames';
import dynamic from 'next/dynamic';
import { HTMLAttributes } from 'react';

import { IZeroElement } from './';
import { ZeroStatic } from './ZeroStatic';

const WaveDynamic = dynamic(() => import('./WaveDynamic'), {
  loading: () => null,
  ssr: true,
});

export function ZeroElement(props: IZeroElement & HTMLAttributes<HTMLElement>) {
  const {
    placeholderImage = null,
    noDelay = false,
    className,
    videoAsset,
    imageAsset,
    assetType,
    customClass,
    activeSlideIndex,
    canPlayVideo = null,
    fadeDirection = 'none',
    index,
    //autoHeight = true,
    truePosition = 'absolute top-0 left-0',
    type,
    colour,
    ...rest
  } = props;

  return (
    <>
      {(type === 'fluid' || type === 'static') && (
        <div
          {...rest}
          className={cn(
            className,
            'w-full flex items-center h-full',
            truePosition,
          )}
        >
          {type === 'fluid' && (
            <WaveDynamic
              imageAsset={imageAsset}
              videoAsset={videoAsset}
              assetType={assetType}
              colour={colour}
            />
          )}
          {type === 'static' && (
            <ZeroStatic
              noDelay={noDelay}
              placeholderImage={placeholderImage}
              fadeDirection={fadeDirection}
              index={index}
              activeSlideIndex={activeSlideIndex}
              type={type}
              imageAsset={imageAsset}
              videoAsset={videoAsset}
              colour={colour}
              assetType={assetType}
              customClass={customClass}
              canPlayVideo={canPlayVideo}
            />
          )}
        </div>
      )}
      {type === 'empty' && (
        <div
          className={cn(
            'absolute -ml-[36vh] md:-ml-[42.5vh] left-[50%] h-[72vh] md:h-[85vh] w-[72vh] md:w-[85vh]',
          )}
        >
          <div className={cn('zeroRing')}></div>
        </div>
      )}
    </>
  );
}
